/**
 * @title retainSearchTerm.js: Feature level module
 * @description This module is a helper for storing the users' search terms 
 * @EnablerStory STRY0163174
 */

define([], function(){
	let retainSearchTerm = {
			
		KEYWORD: 'keyword',
			
		init: function(){
			let searchTerm = COSTCO.util.getParameterByName(retainSearchTerm.KEYWORD);
			
			if(searchTerm != null){
				retainSearchTerm.loadTerm(searchTerm);
			}
			retainSearchTerm.closeButton();
			retainSearchTerm.setListenerOnDeleteButton();
		},
		/**
		 * This function loads the previously saved term 
		 * (if available)into the search field 
		 * @param(String) 
		 *  
		 */
		loadTerm: function(searchTerm){
			$('#search-field').val(searchTerm);
		},
		/**
		 * This function is a listener to close and 
		 * delete the search term upon the users request
		 */
		setListenerOnDeleteButton: function(){
			$('#retain-search-close').on('click', function(){ 
				retainSearchTerm.deleteSearchFieldText();
				$(this).css('display', 'none');
			});
			$('#retain-search-close').on('keydown',function(e){
				retainSearchTerm.keyboardFunctionality(e);
			});
		},
		/**
		 * This function selects the text and deletes it 
		 * This simulates a user deleting text so that typeahead 
		 * gets a new value of empty and does not retain past search history 
		 */
		deleteSearchFieldText: function(){
			let searchField = $('#search-field');
			
			searchField.select();
			document.execCommand('delete');
			
			if(searchField.val() !== ''){
				searchField.val('');
				searchField.select();
				document.execCommand('delete');
			}
		},
		/**
		 * This function is a listener on the search form 
		 * when focused in, it will display the close button
		 * with a condition: searchfield value = search term previously searched
		 * if the user manipulates the text we remove the close button as well
		 */
		closeButton: function(){ 
			$('#formcatsearch').on('focusin',function(){
				if($('#search-field').val() !== ''){
					$('#retain-search-close').css('display', 'flex');
				}
				$('#search-field').on('keyup', function(){
					if($('#search-field').val() !== ''){
						$('#retain-search-close').css('display', 'flex');
					} else {
						$('#retain-search-close').css('display', 'none');
					}
				});
			});
		},
		/**
		 * on enter (13) or space (32)
		 * the search term will be deleted
		 */
		keyboardFunctionality: function(e){
			switch(e.keyCode){
			case(13): 	
				e.preventDefault();
    			retainSearchTerm.deleteSearchFieldText();
    			break;
			case(32):	
				e.preventDefault();
				retainSearchTerm.deleteSearchFieldText();
				break;
			default: 
				break;
			}
		},
			
	}
	if (typeof window.COSTCO == 'undefined'){
	    window.COSTCO = new Object();
    }
	window.COSTCO.retainSearchTerm = retainSearchTerm;
	    return retainSearchTerm;
})


// WEBPACK FOOTER //
// ./js/search/retainSearchTerm.js